import { render, staticRenderFns } from "./form.vue?vue&type=template&id=4faae326"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4faae326')) {
      api.createRecord('4faae326', component.options)
    } else {
      api.reload('4faae326', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=4faae326", function () {
      api.rerender('4faae326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/masters/other/form.vue"
export default component.exports